module.exports = __webpack_public_path__ + "img/RW.d19e3aab.svg";